export const icons = [
	'add_circle',
	'bug_report',
	'cancel',
	'chevron_left',
	'chevron_right',
	'content_copy',
	'download',
	'delete',
	'description',
	'do_not_disturb_on',
	'drag_indicator',
	'edit',
	'filter_list',
	'filter_alt',
	'functions',
	'group',
	'help',
	'info',
	'ink_highlighter',
	'ink_highlighter_move',
	'keep',
	'keyboard_arrow_up',
	'keyboard_arrow_right',
	'keyboard_arrow_left',
	'keyboard_arrow_down',
	'label',
	'lock',
	'mood',
	'more_horiz',
	'more_vert',
	'open_in_new',
	'perm_media',
	'person',
	'person_shield',
	'swap_vert',
	'stacks',
	'sentiment_satisfied',
	'star',
	'sell',
	'sync',
	'undo',
	'visibility',
	'visibility_lock',
	'visibility_off'
];